import { render, staticRenderFns } from "./SystemSetting.vue?vue&type=template&id=2bb57f3d&scoped=true&"
import script from "./SystemSetting.vue?vue&type=script&lang=ts&"
export * from "./SystemSetting.vue?vue&type=script&lang=ts&"
import style0 from "./SystemSetting.vue?vue&type=style&index=0&id=2bb57f3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb57f3d",
  null
  
)

export default component.exports